import { FunctionComponent, ReactNode } from 'react';

export interface ContentCardProps {
  children: ReactNode;
  className?: string;
  padding?: string;
}

export const ContentCard: FunctionComponent<ContentCardProps> = ({
  children,
  className = '',
  padding = 'p-6',
}) => {
  return (
    <div
      className={`bg-background-paper custom-box-shadow rounded ${padding} ${className}`}
    >
      {children}
    </div>
  );
};
